import * as Highcharts from "highcharts";
import { getChartTheme } from './utils/chartTheme';

declare const weed_dow : any[];
declare const weed_monthly : any[];

function stats() {
    if(typeof weed_dow === 'undefined') {
        return;
    }

    // Day of week chart — grouped 2-series (puffs + THC drinks), D-02: no
    // grouping option is overridden, so Highcharts defaults to side-by-side bars.
    Highcharts.chart('chart_dow', Highcharts.merge(getChartTheme(), {
        chart: { type: 'column', height: 320 },
        title: { text: 'Puffs & THC by Day of Week', style: { fontSize: '14px' } },
        xAxis: {
            categories: weed_dow.map(d => d.name),
        },
        yAxis: {
            title: { text: '' },
            gridLineWidth: 0.1
        },
        legend: { enabled: true },
        series: [
            { type: 'column', name: 'Puffs', data: weed_dow.map(d => d.puffs_total), color: '#4CAF50' },
            { type: 'column', name: 'THC Drinks', data: weed_dow.map(d => d.thc_total), color: '#8BC34A' }
        ],
        credits: { enabled: false }
    }));

    // Monthly totals chart — grouped 2-series, same D-02 side-by-side rule.
    Highcharts.chart('chart_monthly', Highcharts.merge(getChartTheme(), {
        chart: { type: 'column', height: 320 },
        title: { text: 'Puffs & THC by Month', style: { fontSize: '14px' } },
        xAxis: {
            categories: weed_monthly.map(d => d.month),
            labels: { rotation: -45 }
        },
        yAxis: {
            title: { text: '' },
            gridLineWidth: 0.1
        },
        legend: { enabled: true },
        series: [
            { type: 'column', name: 'Puffs', data: weed_monthly.map(d => d.puffs_total), color: '#4CAF50' },
            { type: 'column', name: 'THC Drinks', data: weed_monthly.map(d => d.thc_total), color: '#8BC34A' }
        ],
        credits: { enabled: false }
    }));
}

export default class {
    static init = () => {
        stats();
    }
}
